<template>

<li class="dropright" v-show="tab.Children.length > 0">
    <a class="dropdown-item  dropdown-toggle" data-toggle="dropdown" href="#">{{ tab.Name }}</a>
    <ul class="dropdown-menu">
        <li v-for="s in tab.Children" :key="s.Id">
            <nav-item-tree v-if="s.Children.length > 0" :tab="s">
            </nav-item-tree>
            <router-link v-else class="dropdown-item sub-menu-item" :to="{ name: s.Id }">
                {{s.Name}}
            </router-link>
        </li>
    </ul>
</li>

</template>

<script>
import $ from 'jquery';
export default {
    name: 'nav-item-tree',
    props: {
        tab: Object
    },
    data: function () {
        return {

        }
    },
    mounted: function() {
        $('.sub-menu-item').on('click', function() {
            var parent = $(this).parents('ul.dropdown-menu.show');
            $(parent).removeClass('show');
        });
    },
    methods: {

    }
}
</script>